import { QueryClient } from '@tanstack/react-query';
import { ErrorCode } from '@/lib/errors/codes';
import { getErrorCode } from '@/lib/errors/get-error';
import { mutationCache } from './mutation-cache';
import { queryCache } from './query-cache';

// Une erreur métier (code stable) est déterministe : rejouer redonnerait la
// même réponse — le 401 en particulier est déjà couvert par le refresh-on-401
// du client GraphQL. Seul le transitoire (réseau, 503) mérite un retry.
export function shouldRetryQuery(
  failureCount: number,
  error: unknown,
): boolean {
  const code = getErrorCode(error);
  if (code !== undefined && code !== ErrorCode.SERVICE_UNAVAILABLE) {
    return false;
  }
  return failureCount < 3;
}

export const queryClient = new QueryClient({
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: shouldRetryQuery,
    },
  },
});
